import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import Translation from "../../../../common/translation/translation.component";
import { CONFIRMATION_VALUE, TRANSLATIONS as translation } from '../../../../../utils/constant.utils';
import { ORFButton
    , OR_RRF_Select as Select
    , ORFSearchSuggestions as SearchSuggestions
    , OR_RRF_TextArea as TextArea
} from '../../../../common/forms/order-request-form.component';
import { wirelessOtherActions } from "./../../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-other.reducer";
import { createRequestActions } from "./../../../../../store/external/request-reducer/create-request.reducer";
import { requestLogActions } from "./../../../../../store/external/request-reducer/request-log.reducer";
import { NotificationModal } from '../../../../common/modal/notification-modal.component';
import { ConfirmationNotificationModal } from '../../../../common/modal/confirmation-modal.component';
import { withRouter } from 'react-router-dom';
import { CIRCUIT_STATUS, SUBMIT_REQUEST, SUBMIT_REQUEST_TITLE } from '../../../../../constants/external-constants';
import { Loading } from '../../../../common/loading/index';
import { MAX_LENGTH, REQUEST_TYPES_ID, REQUEST_TYPES_LABEL } from "../../../../../constants/external-constants";

class MobileOtherForm extends Component {
    constructor(props) {
        super(props);
        this.state = {           
            showConModal:false
            ,title: ""
            ,error: false
            ,isSaving: false
        }
    }

    componentWillUnmount() {
        this.props.resetWirelessOtherForm();
        this.props.resetRequestData();
    }

    async componentDidMount() {
        const { isUpdateRequest, takeActionCircuitCode, takeActionCircuitId  } = this.props.createRequest;
        const { requestDetail, fetchSubscriptionByRequestDetail, onLoadUpdateOtherRequest, setLoadForm, onSubscriptionSelect, fetchSubscriptionByValue } = this.props;
        var circuitCodePropName = 'CircuitCode';
        var subscriptionList = [];
        if (takeActionCircuitId) {            
            subscriptionList = await fetchSubscriptionByValue(takeActionCircuitCode, circuitCodePropName);

            onSubscriptionSelect(takeActionCircuitCode, circuitCodePropName, subscriptionList, null, takeActionCircuitId);
        }
        else {
            onSubscriptionSelect('');
        }
  
        if (isUpdateRequest) {
            const currentCircuitCode = requestDetail.requestData.Circuit.CircuitCode;
            setLoadForm(true);
            subscriptionList = await fetchSubscriptionByRequestDetail(currentCircuitCode, circuitCodePropName);
            onLoadUpdateOtherRequest(subscriptionList, circuitCodePropName);
            setLoadForm(false);
        }
    }

    submitRequest = () => { 
        this.setState({showConModal:true})
    }

    handleConfirmationModal = async (buttonType) => {
        if (buttonType === CONFIRMATION_VALUE.Ok) {
            const { submitRequest, fetchRequestLogItems } = this.props;
            this.setState({
                isSaving: true,
            });
            var success = await submitRequest();
            let resultMessage = success.Message;
                if (success.Success) {
                    fetchRequestLogItems(0);
                    this.setState({
                        title: "Success",
                        isSaving: false
                    });
                    const { isUpdateRequest } = this.props.createRequest;
                    resultMessage = isUpdateRequest ? this.toLocaleLanguage("order_has_been_updated") : this.toLocaleLanguage("order_has_been_submitted");
                    this.props.hideRequestModal();
                } else {
                    this.setState({
                        title: "Error",
                        isSaving: false
                    });
                    resultMessage = success.Message ? success.Message : this.toLocaleLanguage("order_save_error_message");
                }
                this.setState( prev => ({
                    showConModal: !prev.showConModal,
                    show:true, 
                    message: resultMessage,
                }))
                    
        } else {
            this.setState({
                showConModal: false
            });
        }
    }

    handleCloseNotif = () => {
        this.setState({ show: false });  
            
        if(this.state.title!=="Error")
        {
            this.props.history.goBack();
        } 
    }

    onClickCancel = () => {
        const { modalClose } = this.props;

        if (modalClose) {
            modalClose();
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    isSameParam = () => {
        const { circuitCode, otherRequestTypeId, otherRequestDetails } = this.props.wirelessOtherFormA;
        const { requestData } = this.props.requestDetail;
        const { wirelessOtherFormA } = this.props;
        const otherRequestTypeIdInt = parseInt(otherRequestTypeId, 10);

        return (
            parseInt(otherRequestTypeIdInt) === REQUEST_TYPES_ID.other
              ? (
                  (wirelessOtherFormA.otherRequestDetails === '' || requestData.Order.RequestDetails === otherRequestDetails) &&
                  requestData.Circuit.CircuitCode === circuitCode &&
                  requestData.Order.RequestType.RequestTypeID === otherRequestTypeIdInt
                )
              : (
                  requestData.Order.RequestType.RequestTypeID === otherRequestTypeIdInt &&
                  requestData.Circuit.CircuitCode === circuitCode &&
                  requestData.Order.RequestDetails === otherRequestDetails
                )
          );
          
    }

    haveError = (value) => {
        this.setState({
            error:value
        })
    }

    validateData = () => {
        const { wirelessOtherFormA } = this.props;
        const { formSubmitted } = this.props.wirelessOtherFormA;
        const { requestOnBehalfData, isRequestOnBehalf, isUpdateRequest } = this.props.createRequest;
        const { otherRequestOptions } = this.props.wirelessOtherRequest;

        if (otherRequestOptions.find(x => parseInt(x.Key) === parseInt(wirelessOtherFormA.otherRequestTypeId) && x.Value === REQUEST_TYPES_LABEL.OTHER) !== undefined ?
            wirelessOtherFormA.otherRequestDetails === '' : !wirelessOtherFormA.circuitId || !wirelessOtherFormA.otherRequestTypeId || !wirelessOtherFormA.otherRequestDetails || formSubmitted) {
            if (wirelessOtherFormA.otherRequestTypeId === '') {
                return true;
            }
            else {
                if (wirelessOtherFormA.otherRequestTypeId === REQUEST_TYPES_ID.other.toString()) {
                    if (this.state.error) {
                            return true; 
                    }
                    else {
                        if (wirelessOtherFormA.otherRequestDetails === '') {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            }
        }

        if (isRequestOnBehalf) {
            if (requestOnBehalfData && requestOnBehalfData.EmployeeId > 0 && wirelessOtherFormA.circuitCode !== '') {
                if (isUpdateRequest) {
                    return this.isSameParam();
                }
            }
        } else {
            if (isUpdateRequest) {
                return this.isSameParam();
            }
        }

        if (wirelessOtherFormA.otherRequestTypeId !== REQUEST_TYPES_ID.other.toString()) {
            if (wirelessOtherFormA.circuitId && wirelessOtherFormA.otherRequestDetails) {
                return false;
            } else {
                return true;
            }
        } else {
            if (this.state.error) {
                return true;
            }
            else {
                return false;
            }
        }
    }
    render() {
        const { subscriptionList, takeActionCircuitCode, isUpdateRequest } = this.props.createRequest;
        const { wirelessOtherFormA, onSubscriptionSelect, fetchSubscriptionByValue } = this.props;
        const { otherRequestOptions, subscription, isFormLoading, isResetLoading } = this.props.wirelessOtherRequest;
        var circuitStatusName = isUpdateRequest && subscriptionList.length ? subscriptionList[0].CircuitStatus : subscription.CircuitStatus != null && subscription.CircuitStatus !== "" ? subscription.CircuitStatus : "";

        return isFormLoading ?
            (<div>
                <Loading />
            </div>) : (
            <div>
                <NotificationModal
                    show={this.state.show}
                    title={this.state.title}
                    message={this.state.message}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal notification-footer modal-text-bold'}
                />
                <ConfirmationNotificationModal 
                    show={this.state.showConModal} 
                    message={isUpdateRequest ? SUBMIT_REQUEST.updateRequest : SUBMIT_REQUEST.submitRequest }
                    title={isUpdateRequest ? SUBMIT_REQUEST_TITLE.updateRequest :SUBMIT_REQUEST_TITLE.submitRequest}
                    handleModal={this.handleConfirmationModal}
                    customClass={'comment-notification-modal modal-text-bold'}
                    disabled={this.state.isSaving}
                />
                <Form role="form"
                    model="wirelessOtherFormA"
                    onSubmit={this.submitRequest}
                >
                    <Row>
                        <Col className='mt-3 required' xs={12} md={12} lg={12}>
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('Request')}`}
                                value={wirelessOtherFormA.otherRequestTypeId}
                                options={otherRequestOptions}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                fieldProp='.otherRequestTypeId'
                            />
                        </Col>
                    </Row>

                    <Row className='search-suggestion'>
                            <Col className={`${wirelessOtherFormA.circuitCode !== '' && wirelessOtherFormA.circuitCode !== 'N/A' ? '' : 'mb-4'} ${wirelessOtherFormA.otherRequestTypeId !== "23" && wirelessOtherFormA.otherRequestTypeId !== 23 ? 'required' : ""}`} xs={12} md={12} lg={12}>
                            { !isResetLoading &&
                                <SearchSuggestions
                                    value={wirelessOtherFormA.circuitCode !== 'N/A' ? wirelessOtherFormA.circuitCode : ''}
                                    label={`${this.toLocaleLanguage('mobile_phone_number')}`}
                                    propDisplay={'CircuitCode'}
                                    options={subscriptionList.length > 0 ? subscriptionList : ''}
                                    onChangeAction={onSubscriptionSelect}
                                    searchAction={fetchSubscriptionByValue}
                                    defaultValue={takeActionCircuitCode}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                    maxLength={MAX_LENGTH.limit_100}
                                    errorMessage={this.toLocaleLanguage('error_mobile_number_not_exist')}
                                    haveError={this.haveError }
                                />
                            }
                        </Col>
                           {wirelessOtherFormA.circuitCode !== 'N/A' && wirelessOtherFormA.circuitCode !== '' && (
                                <div className="pb-15-pl-30">
                                    <span className={circuitStatusName === CIRCUIT_STATUS.inService.name ? "status-inservice" : "status-suspended"}>{circuitStatusName} </span> <span>| </span>
                                    {subscription.VendorName != null && subscription.VendorName !== "" ? subscription.VendorName : <Translation translationKey="no_vendor" />} <span>| </span>
                                    {subscription.PlanName != null && subscription.PlanName !== "" ? subscription.PlanName : <Translation translationKey="no_plan_available" />} <span>| </span>
                                    {subscription.DeviceName != null && subscription.DeviceName !== '' ? subscription.DeviceName : <Translation translationKey="no_device_available" />}
                                </div>
                        )}
                    </Row>
                    <Row>
                    <Col className='request-textarea-container required' xs={12} md={12} lg={12}>
                            <TextArea 
                                label={`${this.toLocaleLanguage('request_details')}`}
                                fieldProp='.otherRequestDetails'
                                value={wirelessOtherFormA.otherRequestDetails}
                                maxLength={MAX_LENGTH.limit_1000}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                            />
                        </Col>
                    </Row>
                    <div className="request-button-continer mt-0">
                        <div className="bottom-left">
                            <ORFButton
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={this.onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                    <ORFButton
                                        label={this.toLocaleLanguage('submit_request_button')}
                                        variant={"primary"}
                                        type="submit"
                                        disabled={ this.validateData() }
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};

export default withRouter (connect(
    state => {
        const { createRequest, wirelessOtherRequest, translation, requestDetail } = state;
        const { wirelessOtherFormA } = state.form;
        return {
            wirelessOtherFormA
            , createRequest
            , wirelessOtherRequest
            , ...translation
            , requestDetail
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, wirelessOtherActions
                , createRequestActions
                , requestLogActions),
            dispatch
        )
)(MobileOtherForm));